export default __webpack_public_path__ + "static/media/loginSm.47aadad0.jpg";